import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { ROUTE } from "../../route/Route";
import AccordionUrl from "../../Component/PathlogyTestCity/Accordion";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { DashboardService } from "../../redux/dashboard/service";
import {
  setSelectedCityDataResponse,
  setselectedCityResponse,
} from "../../redux/dashboard/reducer";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function Footer(props: any) {
  const { t, i18n } = useTranslation();
  const { cityData, setCity, setModalIsOpenToTrue } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [opne, setOpne] = useState("");
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const location = useLocation();
  const [presenceCities, setPresenceCities] = useState<any[]>([]);

  useEffect(() => {
    let active = true;
    DashboardService.getInstance().getPresenceCities()
      .then((response: any) => {
        const cities = response?.Result?.Cities;
        if (active) setPresenceCities(Array.isArray(cities) ? cities : []);
      })
      .catch(() => {
        if (active) setPresenceCities([]);
      });
    return () => { active = false; };
  }, []);

    const relatedBlogsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const target = relatedBlogsRef.current;
    if (!target) return;

    // Insert the script after mounting so the embed executes in React.
    const script = document.createElement("script");
    script.defer = true;
    script.src = "https://answers.oncquestlabs.com/_plugins/related-blogs/embed.js";
    script.setAttribute("data-tenant-id", "12");
    script.setAttribute("data-target", "#intunely-answers-oncquestlabs-com-related-blogs");
    script.setAttribute("data-heading", "Related blogs");
    script.setAttribute("data-limit", "3");
    target.insertAdjacentElement("afterend", script);

    return () => {
      script.remove();
    };
  }, []);

  useEffect(() => {
    let pathArray: any[] = location.pathname?.replace("/", "").split("/") || [];
    if (pathArray?.length > 1 && pathArray?.[0] === "pathology-test") {
      const _selectedCity = cityData?.find(
        (ele: any) => ele?.Name?.toLowerCase() == pathArray?.[1]?.toLowerCase()
      );
      if (_selectedCity?.Id) {
        setCity(_selectedCity?.Id);
        dispatch(setselectedCityResponse(_selectedCity?.Id || ""));
        dispatch(setSelectedCityDataResponse(_selectedCity || {}));
        localStorage.setItem("oq:city", _selectedCity?.Id || "");
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const RedirectCenter = async (e: any, Id: any) => {
    const _selectedCity = presenceCities.find((ele: any) => ele?.Id == Id);
    e.preventDefault();
    await setCity(Id);
    dispatch(setSelectedCityDataResponse(_selectedCity || {}));
    await localStorage.setItem("oq:city", Id || "");
    history.push(ROUTE.CENTER);
  };
  let year = new Date().getFullYear();

  return (
    <>
      <div className="pt-2">
        <AccordionUrl />
      </div>
       <div id="intunely-answers-oncquestlabs-com-related-blogs" ref={relatedBlogsRef}></div>
      <footer className="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-2 col-md-4">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu"
                      : "footer-widget footer-menu"
                  }
                >
                  <h2
                    className={
                      opne == "opne1"
                        ? "footer-title btnm on1"
                        : "footer-title btnm "
                    }
                    onClick={() => {
                      if (opne == "opne1") {
                        setOpne("");
                      } else {
                        setOpne("opne1");
                      }
                    }}
                  >
                    {t("comp")}
                  </h2>
                  <ul
                    className="footer-content"
                    style={
                      windowDimensions.width > 767
                        ? { display: "block" }
                        : opne == "opne1"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <li>
                      <Link to={ROUTE.OVERVIEW}>{t("about_us")}</Link>
                    </li>
                    <li>
                      <Link to={ROUTE.DIRECTORMESSAGE}>
                        {t("director_message")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.ENDEVOUR}>{t("vision")}</Link>
                    </li>
                    {/* <li><Link to={ROUTE.ENDEVOUR}>Mission</Link></li> */}
                    {/* <li><Link to={ROUTE.ACCREDATITION}>Investors</Link></li> */}
                    <li>
                      <Link to={ROUTE.ACCREDATITION}>{t("arrd")}</Link>
                    </li>
                    <li>
                      <Link to={ROUTE.AWARD}>{t("award")}</Link>
                    </li>
                    <li>
                      <Link to={ROUTE.CENTER}>{t("our_network")}</Link>
                    </li>
                    {/* <li><Link to={ROUTE.NEWSANDUPDATES}>News/Announcements</Link></li> */}
                    <li>
                      <Link to={ROUTE.NEWSANDUPDATES}>{t("cme")}</Link>
                    </li>
                    <li>
                      <a
                        href="https://oncquestlabs.com/blog/"
                        target="_blank"
                        onClick={(e: any) => {
                          e.preventDefault();
                          window.open(
                            "https://oncquestlabs.com/blog/",
                            "_blank"
                          );
                        }}
                      >
                        {t("blog")}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://answers.oncquestlabs.com/"
                        target="_blank"
                        onClick={(e: any) => {
                          e.preventDefault();
                          window.open(
                            "https://answers.oncquestlabs.com/",
                            "_blank"
                          );
                        }}
                      >
                        {t("Answers")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-4">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu"
                      : "footer-widget footer-menu"
                  }
                >
                  <h2
                    className={
                      opne == "opne2"
                        ? "footer-title btnm on1"
                        : "footer-title btnm "
                    }
                    onClick={() => {
                      if (opne == "opne2") {
                        setOpne("");
                      } else {
                        setOpne("opne2");
                      }
                    }}
                  >
                    {t("patients")}
                  </h2>
                  <ul
                    className="footer-content"
                    style={
                      windowDimensions.width > 767
                        ? { display: "block" }
                        : opne == "opne2"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <li>
                      <Link
                        to={{
                          pathname: ROUTE.BOOKATEST,
                          state: {
                            tabs: "tests",
                            categoryId: "",
                            subCategoryId: "",
                          },
                        }}
                      >
                        {t("test_book")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.OFFER}>{t("disc")}</Link>
                    </li>
                    {/* <li><Link to={ROUTE.SERACHFORTEST}>Search for Tests by Condition</Link></li> */}
                    <li>
                      <Link
                        to={{ pathname: ROUTE.CENTER, state: { nearBy: true } }}
                      >
                        {t("center")}
                      </Link>
                    </li>
                    {/* <li><a href="" onClick={(e:any) => {e.preventDefault(); history.push(ROUTE.BOOKATEST, {tabs: "tests", categoryId:"" ,subCategoryId: ""})}}>Search for Tests</a></li> */}
                    <li>
                      <Link
                        to={{
                          pathname: ROUTE.PREVENTIVEHEALTHPKJ,
                          state: {
                            tabs: "packages",
                            categoryId: "",
                            subCategoryId: "",
                            scrollToSection: true ,
                          },
                        }}
                      >
                        {t("package")}
                      </Link>
                    </li>
                    {/* <li><Link to={ROUTE.OFFER}>Search for Discounts</Link></li> */}
                    <li>
                      <Link to={ROUTE.BLOODSAMPLEHOMECOLLECTION}>
                        {t("query_form")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{ pathname: ROUTE.TESTIMONIAL, state: { type: 1 } }}
                      >
                        {t("testi")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.FAQ}>{t("faq")}</Link>
                    </li>
                    <li>
                      <Link to={ROUTE.QUICKLINKS}>{t("quick_link")}</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg col-md-4">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu"
                      : "footer-widget footer-menu"
                  }
                >
                  <h2
                    className={
                      opne == "opne3"
                        ? "footer-title btnm on1"
                        : "footer-title btnm "
                    }
                    onClick={() => {
                      if (opne == "opne3") {
                        setOpne("");
                      } else {
                        setOpne("opne3");
                      }
                    }}
                  >
                    {t("doctors")}
                  </h2>
                  <ul
                    className="footer-content"
                    style={
                      windowDimensions.width > 767
                        ? { display: "block" }
                        : opne == "opne3"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    {/* <li><Link to={ROUTE.SERACHFORTEST} title="">Search for Tests by Speciality</Link></li> */}
                    {/* <li><Link to="#" title="">Test Clinical Forms</Link></li> */}
                    <li>
                      <Link to={ROUTE.DEPARTMENT} title="">
                        {t("department")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.BROCHURES} title="">
                        {t("brochures")}
                      </Link>
                    </li>
                    {/* <li><a href="#" title="" onClick={(e: any) => { e.preventDefault(); setModalIsOpenToTrue(); }}>Newsletters</a></li> */}
                    {/* <li><Link to={ROUTE.NEWSANDUPDATES} title="">Events</Link></li> */}
                    {/* <li><Link to={ROUTE.PATHSHALA}>{t("paathshala")}</Link></li> */}
                    {/*   <li><Link to={ROUTE.ECME}>CME</Link></li> */}
                    <li>
                      <Link
                        to={{ pathname: ROUTE.TESTIMONIAL, state: { type: 2 } }}
                      >
                        {t("testi")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg col-md-3">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu"
                      : "footer-widget footer-menu"
                  }
                >
                  <h2
                    className={
                      opne == "opne4"
                        ? "footer-title btnm on1"
                        : "footer-title btnm "
                    }
                    onClick={() => {
                      if (opne == "opne4") {
                        setOpne("");
                      } else {
                        setOpne("opne4");
                      }
                    }}
                  >
                    {t("contact")}
                  </h2>
                  <ul
                    className="footer-content"
                    style={
                      windowDimensions.width > 767
                        ? { display: "block" }
                        : opne == "opne4"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <li>
                      <Link to={ROUTE.CORPORATEOFFICE} title="">
                        {t("office")}
                      </Link>
                    </li>
                    {/* <li><Link to={ROUTE.CORPORATEOFFICE} title="">Clinical Trials</Link></li> */}
                    {/* <li><Link to={ROUTE.CORPORATEOFFICE} title="">Regional  Office</Link></li>
									<li><Link to={ROUTE.CORPORATEOFFICE} title="">General Information</Link></li> */}
                    <li>
                      <Link to={ROUTE.GENERALENQUIRY} title="">
                        {t("enquiry")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.HEALTHENQUIRY} title="">
                        {t("corporate")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.CAREER} title="">
                        {t("career")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg col-md-3">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu"
                      : "footer-widget footer-menu"
                  }
                >
                  <h2
                    className={
                      opne == "opne5"
                        ? "footer-title btnm on1"
                        : "footer-title btnm "
                    }
                    onClick={() => {
                      if (opne == "opne5") {
                        setOpne("");
                      } else {
                        setOpne("opne5");
                      }
                    }}
                  >
                    {t("partner")}
                  </h2>
                  <ul
                    className="footer-content"
                    style={
                      windowDimensions.width > 767
                        ? { display: "block" }
                        : opne == "opne5"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <li>
                      <Link to={ROUTE.BECOMWEPARTNER} title="">
                        {t("partner_page")}
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTE.CLINICALTRIAL} title="">
                        {t("clinical_trial")}
                      </Link>
                    </li>
                    {/* <li><Link to={ROUTE.BECOMEVENDOR} title="">Become a vendor</Link></li> */}
                    {/*  <li><a href="" onClick={(e: any) => { e.preventDefault(); history.push(ROUTE.TESTIMONIAL, { type: 3 }) }}>Testimonial</a></li> */}
                  </ul>
                </div>
              </div>
              <div className="col-lg col-md-3">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu"
                      : "footer-widget footer-menu"
                  }
                >
                  {" "}
                  {/* nested_menu */}
                  <h2
                    className={
                      opne == "opne6"
                        ? "footer-title btnm on1"
                        : "footer-title btnm "
                    }
                    onClick={() => {
                      if (opne == "opne6") {
                        setOpne("");
                      } else {
                        setOpne("opne6");
                      }
                    }}
                  >
                    {t("logins")}
                  </h2>
                  <ul
                    className="footer-content"
                    style={
                      windowDimensions.width > 767
                        ? { display: "block" }
                        : opne == "opne6"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    {/* <li><a href="https://lis.oncquest.net/labmatefranchises_7001/" target="_blank" rel="noopener noreferrer" title="">{t("f_partner")}</a></li>
                                        <li><a href="https://lis.oncquest.net/labmateonline_7001/" target="_blank" rel="noopener noreferrer" title="">{t("lis_login")}</a></li> */}
                    <li>
                      <a
                        href="https://itd.oncquest.net/Oncquest/Design/onlinelab/"
                        rel="noopener noreferrer"
                        target="_blank"
                        title=""
                      >
                        {t("report")}
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="https://admin.oncquestlabs.com/search-tests"
                        target="_blank"
                        rel="noopener noreferrer"
                        title=""
                      >
                        {t("range")}
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>

              <div className="col-lg col-md-3">
                <div
                  className={
                    i18n.language === "ta"
                      ? "tamil-class-fo footer-widget footer-menu widgetlast"
                      : "footer-widget footer-menu widgetlast"
                  }
                >
                  <h2 className="footer-title">{t("arrd")}</h2>
                  <div className="footer-about-content nabl-logo">
                    {/* <img src="/assets/img/cap.png" alt="" className="scale"/> */}
                    <img
                      src="/assets/img/nabl_logo.webp"
                      alt=""
                      className="scale"
                    />
                  </div>
                  <h2 className="footer-title pt-3">{t("contact")}</h2>
                  <div className="footer-about-content">
                    <ul className="social">
                      <li>
                        <a
                          href="https://www.facebook.com/OncquestLaboratories/?ref=aymt_homepage_panel"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="facebook"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/img/fb.webp"
                            alt=""
                            className="scale"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/oncquestlab/"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="instagram"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/img/insta.webp"
                            alt=""
                            className="scale"
                          />{" "}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com/Oncquest1?t=U1pQPbKhT53oZSpBuqXDDw&s=09"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="twitter"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/img/twitter.webp"
                            alt=""
                            className="scale"
                          />{" "}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/oncquest-labs-ltd-?trk=tyah&trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A706323%2Cidx%3A1-1-1%2CtarId%3A1477484437069%2Ctas%3Aoncquest"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="linkedin"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/img/in.webp"
                            alt=""
                            className="scale"
                          />{" "}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/c/OncquestLaboratoriesLtd"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="youtube"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/img/youtube.webp"
                            alt=""
                            className="scale"
                          />{" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="countrybx">
                  <h6>
                    {t("our_presence")}&nbsp;
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </h6>
                  <ul>
                    {presenceCities.map((item: any, i: any) => (
                        <li key={i}>
                          <a
                            href="#"
                            title=""
                            onClick={(e: any) => RedirectCenter(e, item?.Id)}
                          >
                            {t(item?.Name)}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="copyright">
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <div className="copyright-text text-center">
                    <p className="mb-0">
                      {t("copyright")} © {year} Oncquest -{" "}
                      {t("all-rights-reserved")}{" "}
                      <a
                        href="https://abym.in/"
                        target="_blank"
                        className="font-weight-bolder"
                        rel="noopener noreferrer"
                      >
                        <b>AbyM Technology</b>
                        <span className="cp-right"> -- v2.18.04.25.1 </span>
                      </a>
                      {t("design_dev")}
                    </p>
                    <ul>
                      <li>
                        <Link to={ROUTE.PRIVACY} className="px-1">
                          {t("privacy_policy")}
                        </Link>{" "}
                        |{" "}
                      </li>
                      <li>
                        <Link to={ROUTE.TERMSCONDITION} className="px-1">
                          {t("term_condition_footer")}
                        </Link>{" "}
                        |{" "}
                      </li>
                      <li>
                        <Link to={ROUTE.DISCLAIMER} className="px-1">
                          {t("declaimer")}
                        </Link>{" "}
                        |{" "}
                      </li>
                      <li>
                        <Link to={ROUTE.SITEMAP} className="px-1">
                          {t("sitemap")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
